/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  DataTable,
  DataTableFilterEvent,
  DataTableFilterMeta,
  DataTablePageEvent,
  DataTableSortEvent,
} from 'primereact/datatable';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import './ReportsTable.module.scss';

interface Props<T extends Record<string, any>> {
  data: T[];
  filters: DataTableFilterMeta;
  setFilters: (filters: DataTableFilterMeta) => void;
  header: ReactNode;
  children: ReactNode;
  dataKey?: string;
  globalFilterFields?: string[];
  onFilter?: (e: DataTableFilterEvent) => void;
  loading?: boolean;
  totalRecords: number;
  onPage: (e: DataTablePageEvent) => void;
  first: number;
  rows: number;
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
  onSort?: (e: DataTableSortEvent) => void;
}

const ReportsTable = <T extends Record<string, any>>({
  data,
  filters,
  setFilters,
  header,
  children,
  dataKey,
  globalFilterFields = [],
  onFilter,
  loading = false,
  totalRecords,
  onPage,
  first,
  rows,
  sortField,
  sortOrder,
  onSort,
}: Props<T>) => {
  const { t } = useTranslation();

  return (
    <DataTable
      value={data as any}
      paginator
      lazy
      totalRecords={totalRecords}
      onPage={onPage}
      first={first}
      rows={rows}
      rowsPerPageOptions={[10, 20, 50]}
      filters={filters}
      globalFilterFields={globalFilterFields}
      header={header}
      emptyMessage={t('common.emptyMessage')}
      loading={loading}
      onFilter={(e) => {
        if (onFilter) {
          onFilter(e);
        } else {
          setFilters(e.filters);
        }
      }}
      dataKey={dataKey}
      className="reports-table"
      sortField={sortField}
      sortOrder={sortOrder === 'asc' ? 1 : -1}
      onSort={onSort}
    >
      {children}
    </DataTable>
  );
};

export default ReportsTable;
